/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileTextGear = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 2H4v20h8v-2H6V4h7v5h5v3h2V7.586l-.293-.293-5-5L14.414 2H14zm11.586 5H15V5.414zM8 13h8v-2H8zm0 4h5v-2H8zm9.5-3v1.145c-.233.07-.455.162-.665.276l-.81-.81-1.414 1.414.81.81a3.44 3.44 0 0 0-.276.665H14v2h1.145c.07.233.162.455.276.665l-.81.81 1.414 1.414.81-.81c.21.114.432.207.665.276V23h2v-1.145c.233-.07.455-.162.665-.276l.81.81 1.414-1.414-.81-.81a3.44 3.44 0 0 0 .276-.665H23v-2h-1.145a3.481 3.481 0 0 0-.276-.665l.81-.81-1.414-1.414-.81.81a3.481 3.481 0 0 0-.665-.276V14zm1 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileTextGear as FileTextGear };
